// extracted by mini-css-extract-plugin
module.exports = {"swipeContainer":"SwipeArea_swipeContainer__2FGtw","appHolderSwipe":"SwipeArea_appHolderSwipe__3gwyi"};